import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Popover } from 'antd';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import IconButton from '@components/IconButton';
import { useHasPermissions } from '@authorisation/hooks';
import { Permissions } from '@authorisation/constants';
import VerificationModal from './VerificationModal';
import './styles.less';

const AppUserVerification = ({ appUser, displayType, enableVerificationModal }) => {
  const [showModal, setShowModal] = useState(false);
  const hideVerificationModal = () => setShowModal(false);
  const showVerificationModal = event => {
    event.stopPropagation();
    event.preventDefault();
    setShowModal(true);
  };

  const dt = displayType ? displayType : 'both';
  return (
    <>
      <span
        class={`app-user-verification-icons ${enableVerificationModal ? 'interactable' : ''}`}
        onClick={
          enableVerificationModal
            ? e => {
                showVerificationModal(e);
              }
            : null
        }
      >
        {!appUser.identityVerified && (dt === 'both' || dt === 'identity') ? (
          <Icon type="idcard" />
        ) : null}
        {!appUser.emailVerified && (dt === 'both' || dt === 'email') ? <Icon type="mail" /> : null}
      </span>
      <VerificationModal appUser={appUser} visible={showModal} onCancel={hideVerificationModal} />
    </>
  );
};

const AppUserNameOrEmail = ({
  appUser,
  forceEmailValue = false,
  nameOnly = false,
  displayInline = false,
  linkEmailValue = true,
  enableVerificationModal = true,
  showCancelledInformation = false,
}) => {
  const { t } = useTranslation();
  const { [Permissions.ViewPatients]: canViewPII } = useHasPermissions(Permissions.ViewPatients);
  const obfuscatePIValue = '******';
  const nameValue = forceEmailValue ? appUser.email : appUser.displayName;
  const isEmailValue = forceEmailValue || nameValue === appUser.email;
  const displayMailToLink = isEmailValue && linkEmailValue && canViewPII && appUser.emailVerified;

  let iconsDisplayType = 'both';
  if (forceEmailValue) {
    iconsDisplayType = 'email';
  }

  const appUserNameNameToDisplay = (
    <span className={`${appUser.relationship?.is_cancelled ? 'cancelled' : ''}`}>
      {displayMailToLink ? (
        <a href={`mailto:${nameValue}`}>{nameValue}</a>
      ) : canViewPII ? (
        nameValue
      ) : (
        obfuscatePIValue
      )}
    </span>
  );

  return (
    <div class="app-user-identity">
      <div>
        {appUserNameNameToDisplay}
        {showCancelledInformation && (
          <Popover
            title={t('cards:PatientDetails.labels.disconnected')}
            content={t('cards:PatientDetails.labels.disconnectedInformation')}
            trigger="click"
            placement="bottom"
            overlayClassName="app-user-identity-popover"
          >
            <IconButton icon={faInfoCircle} onClick={() => {}} />
          </Popover>
        )}
      </div>

      {/* {!appUser.identityVerified ? <FontAwesomeIcon icon={faFlag} size={size} /> : null} */}
      <AppUserVerification
        appUser={appUser}
        displayType={iconsDisplayType}
        enableVerificationModal={enableVerificationModal}
      />
      {/* {isEmailValue ? (
          <div className={`tag-container ${displayInline ? 'inline' : ''}`}>
            <Popover
              content={
                <>
                  <p>
                    {t(
                      `cards:PatientDetails.${
                        appUser.emailVerified ? 'emailVerifiedPopover' : 'emailUnverifiedPopover'
                      }.explanation1`,
                    )}
                  </p>
                  <p>
                    {t(
                      `cards:PatientDetails.${
                        appUser.emailVerified ? 'emailVerifiedPopover' : 'emailUnverifiedPopover'
                      }.explanation2`,
                    )}
                  </p>
                </>
              }
              title={t(
                `cards:PatientDetails.${
                  appUser.emailVerified ? 'emailVerifiedPopover' : 'emailUnverifiedPopover'
                }.title`,
              )}
              trigger="hover"
              placement="top"
              overlayClassName="email-verification-tag-popover"
            >
              {appUser.emailVerified ? (
                <Tag color="green">{t('cards:PatientDetails.labels.verified')}</Tag>
              ) : (
                <Tag color="red">{t('cards:PatientDetails.labels.unverified')}</Tag>
              )}
            </Popover>
          </div>
        ) : null} */}
      {/* </p> */}
    </div>
  );
};

export default AppUserNameOrEmail;
